import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { HalfCircleSpinner } from 'react-epic-spinners';

import { base_url } from '../Api/Api';
import { Loader } from '../Global/Loader';

const Addshop = (props) => {

    const [province, setProvince] = useState([]); // province options
    const [City, setCity] = useState([]); // City options
    const [shop, setShop] = useState([]); // shop options
    const [details, setDetails] = useState({
        show: false,
        loading: false,
        errorValid: false,
        errorCity: false,
    });
    const [inputValue, setInputValue] = useState({
        phone: '',
        codePostal: '',
        address: '',
        nameShop: ''
    });
    const [state, setState] = useState({
        openSheetProvince: false,
        openSheetCity: false,
        openSheetShop: false,
        selectedProvinceTitle: '',
        selectedProvinceValue: '',
        selectedCityTitle: '',
        selectedCityValue: '',
        selectedShopTitle: '',
        selectedShopValue: '',
        storeType: '',
        provinceActvie: false,
        cityActvie: false,
        shopActvie: false,
        snkProvince: 0,
        snkCity: 0
    })

    useEffect(() => {

        setTimeout(() => {
            setDetails({
                ...details,
                loading: true
            })
        }, 300);

        // setProvince

        base_url.get("getProvinces")
            .then(response => {
                setProvince(response.data.provinces)
                setState({
                    ...state,
                    provinceActvie: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                    }
                }
            })

        // setStoreType
        base_url.get("storeTypes")
            .then(response => {
                setShop(response.data.storeTypes)
                setState({
                    ...state,
                    shopActvie: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                    }
                }
            })

    }, [])

    useEffect(() => {

        // set Citys

        base_url.get(`cities/${state.selectedProvinceValue}`)
            .then(response => {
                setCity(response.data.cities)
                setState({
                    ...state,
                    cityActvie: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                    }
                }
            })

    }, [state.selectedProvinceValue])

    // open bottom sheet
    const handleSheet = (target, id) => {
        // document.getElementById(id+'-label').classList.add('MuiInputLabel-shrink')
        if (id == 'City' && state.selectedProvinceValue.length == 0) {
            setState({
                ...state,
                snkProvince: state.snkProvince + 2
            })            
            setDetails({
                ...details,
                errorCity: true
            })
        } else {
            setState({
                ...state,
                [target]: true
            })
        }
    }

    // close bottom sheet
    const handleBottomSheet = (isOpen, target) => {
        setState({
            ...state,
            [target]: isOpen
        })
    }

    // set value of
    const handleOptionProvince = (e, target) => {
        let title = `selected${target}Title`
        let value = `selected${target}Value`
        let bottomSheet = `openSheet${target}`
        let label = `${target}-label`
        document.getElementById(label).classList.add('MuiInputLabel-shrink')
        setState({
            ...state,
            [title]: e.target.labels[0].innerText,
            [value]: e.target.value,
            [bottomSheet]: false
        })
        console.log('handleOptionProvince')
    }

    const handleInputValue = (e, target) => {
        setInputValue({
            ...inputValue,
            [target]: e.target.value
        })
        console.log(e.target.value)
    }

    const contniue = () => {

        const data = {
            'mobile': JSON.parse(localStorage.getItem('phoneNumber')),
            'city_id': state.selectedCityValue,
            'phone': inputValue.phone,
            'postal_code': inputValue.codePostal,
            'address': inputValue.address,
            'name': inputValue.nameShop,
            'store_type': state.selectedShopValue
        }
        if (state.selectedCityValue.length !== 0 &&
            inputValue.phone.length == 11 &&
            inputValue.codePostal.length == 10 &&
            inputValue.address.length !== 0 &&
            inputValue.nameShop.length !== 0 &&
            state.selectedShopValue.length !== 0) {

            // localStorage.setItem('shopInfo', JSON.stringify(data));
            console.log(data)
            const headers = {
                "Authorization": '',
                "content-type": "application/json",
            };
            base_url.post(`addStore`, data, {
                headers: headers
            })
                .then(response => {
                    console.log(response.data)
                })
                .catch(error => {
                    if (error.response != undefined) {
                        console.log(error)
                        if (error.response.status == 401) {
                            props.history.push(`/Entrance`)
                        }
                    }
                })
            props.history.push('/Entrance/step4')

        } else {
            setDetails({
                ...details,
                errorValid: true
            })
        }
    }

    return (
        <div className={`entrnc-base shop-info set-shop ${details.loading ? 'active' : ''}`}>
            <Loader
                active={false} />
            <div className="titles-base titles-style-2">
                <h4>
                    <Link to="/Entrance/step4">
                        <i className="icon-arrow-down-sign-to-navigate"></i>
                    </Link>
                    افزودن فروشگاه
                </h4>
            </div>

            <div className="bx-info">
                <div
                    className={`input-form bfr ${state.openSheetProvince ? 'actived' : ''}`}
                    onClick={() => handleSheet('openSheetProvince', 'Province')}>
                    <TextField
                        id="Province"
                        label="استان *"
                        value={state.selectedProvinceTitle} />
                    <i className="icon-arrow-down-sign-to-navigate"></i>
                    <span className={`error-respns ${details.errorValid && state.selectedProvinceTitle.length == 0 ? 'active' : ''}`}>
                        <i className="icon-exclamation-mark"></i>
                        استان خود را انتخاب کنید
                    </span>
                </div>
                <div
                    className={`input-form bfr ${state.openSheetCity ? 'actived' : ''}`}
                    onClick={() => handleSheet('openSheetCity', 'City')}>
                    <TextField
                        id="City"
                        label="شهر *"
                        value={state.selectedCityTitle} />
                    <i className="icon-arrow-down-sign-to-navigate"></i>
                    <span className={`error-respns ${details.errorValid && state.selectedCityTitle.length == 0 ? 'active' : ''}`}>
                        <i className="icon-exclamation-mark"></i>
                        شهر خود را انتخاب کنید
                    </span>
                </div>
                <div className="input-form">
                    <TextField
                        id="standard-basic"
                        label="تلفن ثابت *"
                        onChange={(e) => handleInputValue(e, 'phone')}
                        onInput={(e) => {
                            if (!(/^\d+$/).test(e.target.value)) {
                                e.target.value = ''
                            }
                            e.target.value = e.target.value.slice(0, 11)
                        }} />
                    <span className={`error-respns ${details.errorValid && inputValue.phone.length < 11 ? 'active' : ''}`}>
                        <i className="icon-exclamation-mark"></i>
                        تلفن ثابت را بصورت صحیح  و کامل وارد کنید
                    </span>
                </div>
                <div className="input-form">
                    <TextField
                        id="standard-basic"
                        label="کد پستی *"
                        onChange={(e) => handleInputValue(e, 'codePostal')}
                        onInput={(e) => {
                            if (!(/^\d+$/).test(e.target.value)) {
                                e.target.value = ''
                            }
                            e.target.value = e.target.value.slice(0, 10)
                        }} />
                    <span className={`error-respns ${details.errorValid && inputValue.codePostal.length < 10 ? 'active' : ''}`}>
                        <i className="icon-exclamation-mark"></i>
                        کد پستی را بصورت صحیح  و کامل وارد کنید
                    </span>
                </div>
                <div className="input-form">
                    <TextField
                        id="standard-basic"
                        label="آدرس *"
                        onChange={(e) => handleInputValue(e, 'address')} />
                    <span className={`error-respns ${details.errorValid && inputValue.address.length == 0 ? 'active' : ''}`}>
                        <i className="icon-exclamation-mark"></i>
                        آدرس خود را وارد کنید
                    </span>
                </div>
                <div className="input-form">
                    <TextField
                        id="standard-basic"
                        label="نام فروشگاه *"
                        onChange={(e) => handleInputValue(e, 'nameShop')} />
                    <span className={`error-respns ${details.errorValid && inputValue.nameShop.length == 0 ? 'active' : ''}`}>
                        <i className="icon-exclamation-mark"></i>
                        نام فروشگاه خود را وارد کنید
                    </span>
                </div>
                <div
                    className={`input-form bfr ${details.openSheetShop ? 'actived' : ''}`}
                    onClick={() => handleSheet('openSheetShop', 'Shop')}>
                    <TextField
                        id="Shop"
                        label="نوع فروشگاه *"
                        value={state.selectedShopTitle} />
                    <i className="icon-arrow-down-sign-to-navigate"></i>
                    <span className={`error-respns ${details.errorValid && state.selectedShopTitle.length == 0 ? 'active' : ''}`}>
                        <i className="icon-exclamation-mark"></i>
                        نوع فروشگاه خود را انتخاب کنید
                    </span>
                </div>
                <div className="btn-base btn-black btn-sircle">
                    <Button
                        variant="contained"
                        onClick={contniue}>ادامه</Button>
                </div>
                <div className="conrain-sheet">

                    <SwipeableBottomSheet
                        open={state.openSheetProvince}
                        onChange={(e) => handleBottomSheet(e, 'openSheetProvince')}
                        overflowHeight={0}>
                        <div
                            style={{ height: '400px' }}
                            className="bottom-sheet">
                            <h4>لیست استان ها</h4>
                            <div className="search-bx">
                                <input
                                    type="text"
                                    placeholder="جستجو" />
                                <i className="icon-search"></i>
                            </div>
                            <div className="body-sheet">
                                {
                                    state.openSheetProvince ?
                                        <FormControl
                                            component="fieldset">
                                            <RadioGroup
                                                aria-label="gender"
                                                name="gender1"
                                                value={state.selectedProvinceTitle}
                                                onChange={(e) => {
                                                    handleOptionProvince(e, 'Province')
                                                }} >
                                                {province.length == 0 ?
                                                    state.provinceActvie ?
                                                        <div className="loader-item">
                                                            <HalfCircleSpinner
                                                                size={40}
                                                                color="#152b9f" />
                                                        </div>
                                                        :
                                                        <span className="no-info">موردی برای نمایش وجود ندارد</span>
                                                    :
                                                    province.map((info) =>
                                                        <div className="radio-btn"
                                                            key={info.id}>
                                                            <FormControlLabel
                                                                key={info.id}
                                                                value={info.id}
                                                                control={<Radio />}
                                                                label={info.name} />
                                                        </div>
                                                    )
                                                }
                                            </RadioGroup>
                                        </FormControl>
                                        :
                                        <div className="loader-item">
                                            <HalfCircleSpinner
                                                size={40}
                                                color="#152b9f" />
                                        </div>
                                }
                            </div>
                        </div>
                    </SwipeableBottomSheet>

                    <SwipeableBottomSheet
                        open={state.openSheetCity}
                        onChange={(e) => handleBottomSheet(e, 'openSheetCity')}
                        overflowHeight={0}>
                        <div
                            style={{ height: '400px' }}
                            className="bottom-sheet">
                            <h4>لیست شهر ها</h4>
                            <div className="search-bx">
                                <input
                                    type="text"
                                    placeholder="جستجو" />
                                <i className="icon-search"></i>
                            </div>
                            <div className="body-sheet">
                                {state.openSheetCity ?
                                    <FormControl
                                        component="fieldset">
                                        <RadioGroup
                                            aria-label="gender"
                                            name="gender1"
                                            value={state.selectedCityTitle}
                                            onChange={(e) => {
                                                handleOptionProvince(e, 'City')
                                            }} >
                                            {City.length == 0 ?
                                                state.cityActvie ?
                                                    <div className="loader-item">
                                                        <HalfCircleSpinner
                                                            size={40}
                                                            color="#152b9f" />
                                                    </div>
                                                    :
                                                    <span className="no-info">موردی برای نمایش وجود ندارد</span>
                                                :
                                                City.map((info, index) =>
                                                    <div className="radio-btn"
                                                        key={info.id}>
                                                        <FormControlLabel
                                                            key={info.id}
                                                            value={info.id}
                                                            control={<Radio />}
                                                            label={info.name} />
                                                    </div>
                                                )
                                            }
                                        </RadioGroup>
                                    </FormControl>
                                    :
                                    <div className="loader-item">
                                        <HalfCircleSpinner
                                            size={40}
                                            color="#152b9f" />
                                    </div>
                                }
                            </div>
                        </div>
                    </SwipeableBottomSheet>

                    <SwipeableBottomSheet
                        open={state.openSheetShop}
                        onChange={(e) => handleBottomSheet(e, 'openSheetShop')}
                        overflowHeight={0}>
                        <div
                            style={{ height: 'auto' }}
                            className="bottom-sheet add-shop">
                            <div className="row-head">
                                <h4>نوع فروشگاه ها</h4>
                                <span
                                    onClick={() => setDetails({ ...details, show: !details.show })} >راهنما <i className="icon-exclamation"></i></span>
                            </div>
                            <div className="search-bx">
                                <input
                                    type="text"
                                    placeholder="جستجو" />
                                <i className="icon-search"></i>
                            </div>
                            <div className="body-sheet">
                                {state.openSheetShop ?
                                    <FormControl
                                        component="fieldset">
                                        <RadioGroup
                                            aria-label="gender"
                                            name="gender1"
                                            value={state.selectedShopTitle}
                                            onChange={(e) => {
                                                handleOptionProvince(e, 'Shop')
                                            }} >
                                            {shop.map((info, index) =>
                                                <div className="radio-btn"
                                                    key={info.id}>
                                                    <FormControlLabel
                                                        key={info.id}
                                                        value={info.id}
                                                        control={<Radio />}
                                                        label={info.title} />
                                                    <p className={details.show ? 'show' : ''}>{info.description}</p>
                                                </div>
                                            )}
                                        </RadioGroup>
                                    </FormControl>
                                    :
                                    <div className="loader-item">
                                        <HalfCircleSpinner
                                            size={40}
                                            color="#152b9f" />
                                    </div>
                                }
                            </div>
                        </div>
                    </SwipeableBottomSheet>

                </div>
            </div>

        </div >
    );
}

export default Addshop;